<div class="card">
	<div class="card-header">
		<h1>Cierre y Declaraciones de Impuestos</h1>
	</div>
	<div class="card-body">
		<div class="form-group">
			<label for="year" class="form-label">Año</label>
			<select name="year" [(ngModel)]="year" (change)="cleanAndGet()" class="form-select" id="year">
				<option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
			  </select>
			<p class="form-text" style="font-size: 0.8rem; opacity: 0.7;">
				<i class="fa fa-circle-info"></i>
				En esta sección podrá realizar los cierres por mes. Puede seleccionar un mes disponible para realizar el
				cierre. No podrá realizar cierres en meses
				anteriores al un mes ya cerrado.
			</p>
		</div>
		<hr>
		<div class="row">
			<div class="col-md-3" style="padding: 1em; border: 1px solid var(--bs-bg-servicios);"
				[class.not-yet]="!m.show" *ngFor="let m of months">
				<div class="panel erp-panel">
					<div class="panel-heading erp-panel-heading">
						<h5 class="center-txt">
							<i class="fa fa-calendar-days" aria-hidden="true"></i> {{m.name + ' ' + year}}
						</h5>
					</div>
					<div class="panel-body erp-panel-body">
						<div class="row">
							<div class="">
								<form name="invoiceForm" class="ng-pristine ng-valid ng-valid-date ng-valid-required">

									<!--Aun no es fech para cerrar  -->
									<div class="text-center" *ngIf="!m.show">
										<i class="fa fa-ban" aria-hidden="true"></i>
										<p>
											Aún no es tiempo de generar las declaraciones de este mes.
										</p>
									</div>

									<!-- ya se puede cerrar -->
									<div class="text-center form-height" *ngIf="!m.closureData.id" [hidden]="!m.show">
										<i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
										<p>
											Cierra el mes de para generar tus declaraciones ante la SAT.
										</p>
										<p>
											Una vez realices el cierre ya no podrás ingresar más documentos en este mes.
										</p>
									</div>
									<div class="form-height" *ngIf="m.closureData.id">
										<div *ngFor="let c of clousure">
											<div *ngFor="let x of c; let i = index">

												<div *ngIf="m.closureData.closedMonth == x.monthEnd">

													<div *ngIf="x.status == 10" style="text-align: center;">

														<i *ngIf="i < 1" class="fa-solid fa-triangle-exclamation"
															aria-hidden="true"></i>
														<p *ngIf="i < 1">Ya se cerró el mes pero hay algún formulario
															que
															necesita tu atención.</p>

														<div class="container" style="text-align: left">
															<div *ngIf="i < 1" class="container">
																<i class="fa-solid fa-check-to-slot"
																	aria-hidden="true"></i>Cierre el mes
															</div>
															<div class="container">
																<i class="fa fa-gear" aria-hidden="true"></i>
																{{x.formName}}
															</div>
														</div>


													</div>
													<div *ngIf="x.status == 20" style="text-align: center;">

														<i *ngIf="i < 1" class="fa-solid fa-triangle-exclamation"
															aria-hidden="true"></i>
														<p *ngIf="i < 1">Ya se cerró el mes pero hay algún formulario
															que
															necesita tu atención.</p>

														<div class="container" style="text-align: left">
															<div *ngIf="i < 1" class="container">
																<i class="fa-solid fa-check-to-slot"
																	aria-hidden="true"></i>Cierre el mes
															</div>
															<div class="container">
																<i class="fa fa-gear" aria-hidden="true"></i>
																{{x.formName}}
															</div>
														</div>


													</div>
													<div *ngIf="x.status == 21" style="text-align: center;">

														<i *ngIf="i < 1" class="fa-solid fa-triangle-exclamation"
															aria-hidden="true"></i>
														<p *ngIf="i < 1">Ya se cerró el mes pero hay algún formulario
															que
															necesita tu atención.</p>

														<div class="container" style="text-align: left">
															<div *ngIf="i < 1" class="container">
																<i class="fa-solid fa-check-to-slot"
																	aria-hidden="true"></i>Cierre el mes
															</div>
															<div class="container">
																<i class="fa fa-gear" aria-hidden="true"></i>
																{{x.formName}}
															</div>
														</div>


													</div>
													<div *ngIf="x.status == 30" style="text-align: center;">

														<i *ngIf="i < 1" class="fa-solid fa-triangle-exclamation"
															aria-hidden="true"></i>
														<p *ngIf="i < 1">Ya se cerró el mes pero hay algún formulario
															que
															necesita tu atención.</p>

														<div class="container" style="text-align: left">
															<div *ngIf="i < 1" class="container">
																<i class="fa-solid fa-check-to-slot"
																	aria-hidden="true"></i>Cierre el mes
															</div>
															<div class="container">
																<i class="fa fa-gear" aria-hidden="true"></i>
																{{x.formName}}
															</div>
														</div>


													</div>

													<div *ngIf="x.status == 31" style="text-align: center;">

														<i class="fa-solid fa-triangle-exclamation"
															aria-hidden="true"></i>
														<p>Ya se cerró el mes pero hay algún formulario que necesita tu
															atención.</p>
														<i class="fa-solid fa-check-to-slot" aria-hidden="true"></i>
														<!-- -->
														<br>
														<span><i class="fa fa-gear" aria-hidden="true"></i>
															{{x.formName}}</span>
													</div>

													<div *ngIf="x.status == 40" style="text-align: center;">

														<i *ngIf="i < 1" class="fa fa-check-circle"
															aria-hidden="true"></i>
														<p *ngIf="i < 1"> Mes cerrado correctamente.</p>
														<div class="container">
															<i *ngIf="i < 1" class="fa-solid fa-check-to-slot"
																aria-hidden="true"></i>Cierre el mes
														</div>
														<div class="container">
															<i class="fa-solid fa-check-to-slot" aria-hidden="true"></i>
															{{x.formName}}
														</div>

													</div>

												</div>
											</div>
										</div>
									</div>


									<div class="center-text" style="display: flex;">

										<button class="btn btn-info" style="width: 100%;"
											(click)="goForms(m.closureData.closedMonth)" *ngIf="m.closureData.id">
											<i class="fa fa-eye"></i>
											Ver Declaraciones
										</button>

										<app-loading-button style="width: 100%;" *ngIf="!m.closureData.id && m.show"
											[object]="m.closing" [colorLoading]="'white'" [logo]="true"
											(clicked)="performClosing(m)"></app-loading-button>
										<!-- <button class="btn btn-success" style="width: 100%;" (click)="performClosing(m)"
											*ngIf="!m.closureData.id && m.show">
											<i class="fa fa-check-to-slot" style="color: white !important;"></i>
											Realizar Cierre
										</button> -->
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-modal-tax-return [formList]="formsView" *ngIf="formsView" (close)="formsView = null"></app-modal-tax-return>
<app-modal-question *ngIf="performingMonth!==null && !performingMonth.closing.loading" (close)="closeModal($event)"
	[question]="'Al realizar el cierre todos los documentos ingresados no podrán ser modificados ni eliminados. ¿Está seguro que desea realizar cierre contable para el mes de: '+ monthName[performingMonth.number]+' del '+ year"></app-modal-question>